export default __webpack_public_path__ + "static/media/thumbnail-learn.7f63cc34.webp";